export function isGeoblockActive(mode: string | undefined): boolean {
  return mode === "allow" || mode === "deny";
}
